import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../api/apiSlice";

const pagosAdapter = createEntityAdapter({
  // Assume IDs are stored in a field other than `book.id`
  selectId: (x) => x.pagoId,

  // Keep the "all IDs" array sorted based on book titles
  // sortComparer: (a, b) => a.title.localeCompare(b.title),
})

const initialState = pagosAdapter.getInitialState();

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getPagos: builder.query({
      query: () => 'pagos',
      transformResponse: responseData => {
        return pagosAdapter.setAll(initialState, responseData)
      },
      providesTags: (result, error, arg) => [
        { type: 'Pagos', id: 'LIST' },
      ]
    }),
    addPago: builder.mutation({
      query: (newPago) => ({ url: 'pagos', method: 'post', body: newPago }),
      invalidatesTags: ["Pagos", "Contratos"]
    }),
    editPago: builder.mutation({
      query: (pagoUpdate) => ({ url: `pagos/${pagoUpdate.pagoId}`, method: 'put', body: pagoUpdate }),
      invalidatesTags: ["Pagos", "Contratos"]
    }),
    delPago: builder.mutation({
      query: (pagoId) => ({ url: `pagos/${pagoId}`, method: 'delete'}),
      invalidatesTags: ["Pagos", "Contratos"]
    })
  })
});

export const { useGetPagosQuery, useAddPagoMutation, useEditPagoMutation, useDelPagoMutation } = extendedApiSlice;

//A: returns the query result object
export const selectPagosResult = extendedApiSlice.endpoints.getPagos.select();

//A: created memoized selector
const selectPagosData = createSelector(
  selectPagosResult,
  pagosResult => pagosResult.data  //A: normalized state object with ids and entities
);


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
  selectAll: selectAllPagos,
  selectById: selectPagosById,
  selectIds: selectPagosIds
} = pagosAdapter.getSelectors(state => selectPagosData(state) ?? initialState);

//A:selector for get all payments by contract id
const selectContratoId = (state, contratoId) => contratoId

export const selectPagosByContratoId = createSelector(
  [selectAllPagos, selectContratoId],
  (pagos, contratoId) => pagos.filter(pago => pago.contratoId == contratoId)
)
